import { createApolloClient, createDownloadUrl } from "@briter/elements/networking/graphql";

export const client = createApolloClient(import.meta.env.VITE_ENDPOINT);
export const DOWNLOAD_URL = createDownloadUrl(import.meta.env.VITE_ENDPOINT);
